// extracted by mini-css-extract-plugin
export default {"applyFooter":"filters_footer-module___applyFooter___b2d10060"};